
const nonBreakingSpace = (text: string) => {
  return text.replace(/\s+/g, '\u00a0')
}

export default nonBreakingSpace